/**
 * Created by meikang on 2019/3/7.
 * 基础方法
 */
import Vue from 'vue'
import store from './store';
import contants from './const';

/*
* @brief 注册界面拖动
* */
document.body.addEventListener('touchmove',(event) => {
    if(!event._isScroller) event.preventDefault();
});

/*
* @brief 添加css伪类:active可用
* */
document.body.addEventListener('touchstart', () => {

});

/*
* @brief 发布订阅模式
* */
class EventEmiter {
    constructor() {
        this._events = {}
    }

    listen(eventName, callback) {
        if (this._events[eventName]) {
            this._events[eventName].push(callback);
        } else {
            this._events[eventName] = [callback]
        }
    }

    trigger(eventName, ...rest) {
        if (this._events[eventName]) {
            this._events[eventName].forEach((item) => {
                item.apply(this, rest)
            });
        }
    }

    remove(eventName, callback) {
        if (this._events[eventName]) {
            if(callback) this._events[eventName] = this._events[eventName].filter(item => item !== callback);
            else delete this._events[eventName];
        }
    }
}

class Base {
    constructor() {
        this.event = new EventEmiter();
    }

    static onResize() {
        const width = document.documentElement.clientWidth > 1024 ? 1024 : document.documentElement.clientWidth;

        const zoom = contants.zoom || 7.5;
        let ratio = width / zoom;

        document.documentElement.style.fontSize = ratio + "px";
        store.state.ratio = ratio;
    }

    /*
    * @brief 获取URL参数
    * */
    getUrlParam(paraName) {
        const url = document.location.toString(), arrObj = url.split("?");
        if (arrObj.length > 1) {
            let arrPara = arrObj[1].split("&"), arr;
            for (let i = 0; i < arrPara.length; i++) {
                arr = arrPara[i].split("=");
                if (arr != null && arr[0] == paraName) {
                    return arr[1];
                }
            }
            return "";
        } else return "";
    }

    /*
    * @brief 获取dom
    * */
    getDom(el) {
        return document.querySelector(el);
    }

    /*
    * @brief 界面加载
    * */
    loadInit(initialZoom) {

        /* 设置初始缩放值 */
        contants.zoom = initialZoom;

        Base.onResize();
        window.onload = window.onresize = () => {
            Base.onResize();
        };
    }


    /**
     * @
     * @param {*} zoom
     */
    updateZoom() {
        Base.onResize();
    }


    /*
    * @brief 设置滚动
    * */
    overScroll(el) {
        const dom = document.querySelector(el);
        dom.addEventListener('touchstart', () => {
            const top = dom.scrollTop, totalScroll = dom.scrollHeight, currentScroll = top + dom.offsetHeight;
            if(top === 0) dom.scrollTop = 1;

            else if(currentScroll === totalScroll) dom.scrollTop = top - 1;
        });

        dom.addEventListener('touchmove', (event) => {
            if(dom.offsetHeight < dom.scrollHeight) event._isScroller = true;
        });
    }

    /*
    * @brief 大厅其它模态框POP
    * */
    newAppPop(properties) {

        const _props = properties || {}, that = this;

        let pClass = "tips_box", index, timer;

        if(_props.isAnimated) pClass = "tips_box animated";

        index = _props.index || 100000;

        const Instance = new Vue({
            data: _props,
            render (h) {
                return h('div', {
                    attrs: {
                        class: "app_pop"
                    },
                    style: {zIndex: index}
                }, [
                    h('div', {
                        attrs: {
                            class: "shade"
                        }
                    }),
                    h('div', {
                        attrs: {
                            class: pClass
                        }
                    }, [
                        h( properties.ui, {
                            props: _props,
                            on: {
                                clickRemove: this.remove
                            }
                        })
                    ])
                ]);
            },
            created() {
                //if(that.getDom('.app')) that.getDom('.app').style.filter = 'blur(4px)';
                if(properties.time) timer = setTimeout(this.remove, properties.time);
            },
            methods: {
                changeTime(time) {
                    clearInterval(timer);
                    timer = setTimeout(this.remove, time);
                },
                remove() {
                    this.destroy();
                },
                destroy () { //清除实例
                    this.$el.parentNode.removeChild(this.$el);
                    //if(that.getDom('.app')) that.getDom('.app').style.filter = 'none';
                    this.$destroy();
                }
            }
        });

        const component = Instance.$mount();
        document.body.appendChild(component.$el);
        return component;
    };

}

export default new Base();
